(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.querySelectorAll('product-info').forEach(function(info) {
  function updateTabbyVisibility() {
    var price = info.querySelector('[data-tbrc-variant-price]');
    var tabby = info.querySelector('[data-tbrc-tabby]');
    if (price && tabby) {
      var hidden = Number(price.dataset.tbrcVariantPrice) <= 100000 || price.dataset.tbrcCurrency !== 'AED';
      if (tabby.hidden !== hidden) tabby.hidden = hidden;
    }
  }
  updateTabbyVisibility();
  new MutationObserver(updateTabbyVisibility).observe(info, {childList:true,subtree:true});
});

  } catch(e) { console.error(e); }
})();
})();
